export class VehiculoFuncionarioModel {
    public idVehiculo: number;
    public tipoIdFuncionario: string;
    public numeroIdFuncionario: string;
    public placa: string;
    public estado: string;
    public tipoVehiculo: string;
    public fechaRegistro: Date;
    public fechaModificacion: Date;
    public usuarioModificacion: string;
    public ordenVehiculo: string;
    public otro: string;
}
